<template>
    <div>
        <PageTitle :title="$t('page.title')" icon="pe-7s-global" :subtitle="$t('page.subtitle')">
            <template v-slot:subTitle>
                <span v-if="locations.length > 0">
                    {{ $t('page.subtitle') }}
                </span>
            </template>
        </PageTitle>

        <div class="row">
            <div class="col-6">
                <div v-if="hasAllPermissions('locations.edit.batch', 'locations.servicetimes.edit')" class="form-check" style="line-height:200%;">
                    <input type="checkbox" v-model="isBatchEditEnabled" class="form-check-input" id="isBatchEditEnabledCheckbox"/>
                    <label for="isBatchEditEnabledCheckbox" class="form-check-label">
                        {{ $t('template.buttons.batch-edit.label') }}
                    </label>
                </div>
            </div>
            <div v-if="hasPermission('locations.create')" class="col-6 text-right">
                <router-link tag="a" :to="{name:'locationCreate'}" class="btn btn-primary">
                    {{ $t('template.buttons.create-location.label') }}
                </router-link>
            </div>
            <div class="col-12 mt-2 mb-2">
                <div class="card mb-2">
                    <div class="card-body">
                        <h3 class="card-title">
                          {{ $t('template.filters.title') }}
                        </h3>

                        <div style="clear:both;">
                            <div class="form-row form-group-sm">
                                <div class="col">
                                    <label for="filterStoreIdentifier">
                                      {{ $t('omt.gui.location-management.search.filters.labels.store-identifier') }}
                                    </label>
                                    <input type="text" id="filterName" class="form-control" v-model.trim="filters.identifier"/>
                                </div>

                                <div class="col">
                                    <label for="filterName">
                                      {{ $t('omt.gui.location-management.search.filters.labels.store-name') }}
                                    </label>
                                    <input type="text" id="filterName" class="form-control" v-model.trim="filters.name"/>
                                </div>

                                <div class="col">
                                    <label>
                                      {{ $t('omt.gui.location-management.search.filters.labels.store-type') }}
                                    </label>
                                    <select id="filterType" class="form-control" v-model="filters.type">
                                        <option></option>
                                        <option v-for="type in uniqueTypes" :value="type">{{type}}</option>
                                    </select>
                                </div>

                                <div class="col">
                                    <label>
                                        {{ $t('omt.gui.location-management.search.filters.labels.store-active') }}
                                    </label>
                                    <select id="filterActive" class="form-control" v-model="filters.active">
                                        <option></option>
                                        <option :value="'1'">
                                          {{ $t('omt.gui.general.label.yes') }}
                                        </option>
                                        <option :value="'0'">
                                          {{ $t('omt.gui.general.label.no') }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isBatchEditEnabled" class="col-12 px-0 my-4">
                    <button type="button" class="btn btn-info" :disabled="!locationsSelectedForBatchEdit.length"
                            @click="isModalOpen = isBatchAddOpeningTimesOpen = !isModalOpen">
                            {{ $t('template.buttons.add-custom-opening-times.label') }}
                    </button>
                </div>

                <b-card>
                    <b-card-title class="text-uppercase">
                        {{ $t('template.results.title') }}
                    </b-card-title>
                    <div class="table-responsive">
                    <table class="table table-hover">
                        <colgroup>
                            <col v-if="isBatchEditEnabled" style="width:40px;"/>
                            <col style="width:10%;"/>
                            <col style="width:auto;"/>
                            <col style="width:140px;"/>
                            <col style="width:120px;"/>
                            <col style="width:140px;"/>
                        </colgroup>
                        <tr>
                            <th v-if="isBatchEditEnabled" class="pr-0 py-1 mr-0">
                                <button class="btn btn-sm btn-link p-0" title="Selectie omkeren" @click="invertSelection()" style="line-height:180%;">
                                    <span class="lead">&ne;</span>
                                </button>
                            </th>
                            <th>
                              {{ $t('template.results.table.header.id') }}
                            </th>
                            <th>
                              {{ $t('template.results.table.header.name') }}
                            </th>
                            <th>
                              {{ $t('template.results.table.header.type') }}
                            </th>
                            <th>
                              {{ $t('template.results.table.header.active') }}
                            </th>
                            <th style="width:130px;">
                              {{ $t('template.results.table.header.actions') }}
                            </th>
                        </tr>

                        <tbody>
                        <tr v-for="location in locationsFiltered">
                            <td v-if="isBatchEditEnabled" class="pr-0 mr-0">
                                <input type="checkbox" v-model="location.batch_edit"/>
                            </td>
                            <td>{{location.identifier}}</td>
                            <router-link :to="{name:'locationEditContactInfo', params: { locationTypeIdentifier: location.location_type.identifier, locationIdentifier: location.identifier }}" tag="td"
                                         class="link">
                                {{location.display_name}}
                            </router-link>
                            <td>
                              {{ location.location_type.display_name }}
                            </td>
                            <td>
                                <span v-if="location.active === '1'">
                                  {{ $t('template.results.table.body.active.yes') }}
                                </span>
                                <span v-else>
                                  {{ $t('template.results.table.body.active.no') }}
                                </span>
                            </td>
                            <td class="p-1">
                                <router-link :to="{name:'locationEditContactInfo', params: { locationTypeIdentifier: location.location_type.identifier, locationIdentifier: location.identifier }}" tag="a"
                                             v-if="hasLocationPermission(location.location_type.identifier, location.identifier,'locations.contactinfo.view')"
                                             :title="$t('template.results.table.body.edit-contact-info')"
                                             class="btn btn-sm btn-link text-body">
                                    <font-awesome-icon icon="edit"/>
                                </router-link>
                                <router-link :to="{name:'locationEditServiceTimes', params: { locationTypeIdentifier: location.location_type.identifier, locationIdentifier: location.identifier }}" tag="a"
                                             v-if="hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.servicetimes.edit')"
                                             :title="$t('template.results.table.body.edit-service-times')"
                                             class="btn btn-sm btn-link text-body">
                                    <font-awesome-icon icon="clock"/>
                                </router-link>
                                <router-link :to="{name:'EditLocationServices', params: { locationTypeIdentifier: location.location_type.identifier, locationIdentifier: location.identifier }}" tag="a"
                                             v-if="hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.services.view')"
                                             :title="$t('template.results.table.body.edit-service-settings')"
                                             class="btn btn-sm btn-link text-body">
                                    <font-awesome-icon icon="cube"/>
                                </router-link>
                                <router-link :to="{name:'EditLocationProperties', params: { locationTypeIdentifier: location.location_type.identifier, locationIdentifier: location.identifier }}" tag="a"
                                             v-if="hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.properties.edit')"
                                             :title="$t('template.results.table.body.edit-properties')"
                                             class="btn btn-sm btn-link text-body">
                                    <font-awesome-icon icon="cogs"/>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </b-card>

                <div v-if="isLoading">
                    <font-awesome-icon icon="spinner" spin/>
                </div>
            </div>
        </div>

        <b-modal id="vue-modal"
                 title="Batch Edit"
                 v-model="isModalOpen"
                 :hide-header="true"
                 :hide-footer="true"
                 size="xl"
        >
            <batch-add-opening-times v-if="isBatchAddOpeningTimesOpen" :selected-results="locationsSelectedForBatchEdit" :show-header="true" @close="isModalOpen = false"/>
        </b-modal>
    </div>
</template>

<script>
import _ from "lodash"
import BatchAddOpeningTimes from "./Modals/BatchAddOpeningTimes";
import PageTitle from "../../components/PageTitle";
import {hasAllPermissions} from "../../helpers/permissions";
import i18n from "./Index.i18n";

export default {
    name: "Index",

    components: {
      BatchAddOpeningTimes,
      PageTitle,
    },

    i18n,

    data() {
        return {
            isLoading: true,
            isBatchEditEnabled: false,
            isModalOpen: false,
            isBatchAddOpeningTimesOpen: false,
            locations: [],
            filters: {
                identifier: '',
                name: '',
                type: '',
                active: '',
            },
          };
    },

    computed: {
        uniqueTypes() {
            return _.chain(this.locations)
                .map(l => l.location_type.display_name)
                .uniq()
                .value()
        },
        locationsFiltered() {
            return _.chain(this.locations)
                    .filter(location => this.filters.identifier === '' || location.identifier.toLowerCase().indexOf(this.filters.identifier.toLowerCase()) !== -1)
                    .filter(location => this.filters.name       === '' || location.display_name.toLowerCase().indexOf(this.filters.name.toLowerCase()) !== -1)
                    .filter(location => this.filters.type       === '' || this.filters.type === location.location_type.display_name)
                    .filter(location => this.filters.active     === '' || location.active === this.filters.active)
                    .sortBy(['display_name'])
                    .value()
        },
        locationsSelectedForBatchEdit() {
            return this.locations
                .filter(location => location.batch_edit)
        },
    },

    mounted() {
        this.getLocations()
    },

    methods: {
        getLocations() {
            this.$store.getters.getLocationsForUser
                .then(response => {
                    this.locations = _.cloneDeep(this.$store.state.locationsForUser)
                        .map(location => {
                            location.batch_edit = false
                            return location
                        })

                    this.isLoading = false
                })
        },
        invertSelection() {
            this.locationsFiltered.forEach(location => {
                location.batch_edit = !location.batch_edit
            })
        },
    },
}
</script>

<style lang="scss">
table {
    th {
        background-color: #f4f7fa;
    }
}

.link {
    cursor: pointer;
}
</style>
